import TextButton from 'LuxKit/Button/TextButton'
import LineExternalLinkAltIcon from 'LuxKit/Icons/line/LineExternalLinkAltIcon'
import { rem } from 'polished'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

export const LocationAddressRow = styled.div`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: ${rem(4)} ${rem(12)};
`

interface GoogleMapsSearch {
  query: string
  placeId?: string
}

export function buildGoogleMapsSearchUrl({ query, placeId }: GoogleMapsSearch): string {
  const searchParams = new URLSearchParams({
    api: '1',
    query,
  })

  if (placeId) {
    searchParams.set('query_place_id', placeId)
  }

  return `https://www.google.com/maps/search/?${searchParams.toString()}`
}

function OpenInGoogleMapsButton({ query, placeId }: GoogleMapsSearch) {
  return (
    <TextButton
      kind="tertiary"
      size="small"
      endIcon={<LineExternalLinkAltIcon />}
      href={buildGoogleMapsSearchUrl({ query, placeId })}
      target="_blank"
      rel="noopener noreferrer"
    >
      <FormattedMessage
        id="tiykdL329EkfbK11FWZA"
        defaultMessage="Open in Google Maps"
        description="Link text for opening an offer property's location in Google Maps"
      />
    </TextButton>
  )
}

export default OpenInGoogleMapsButton
